import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { SidebarSearchField } from "../sidebar/SidebarSearchField";
export const ErrorView = ({ children, className, error, ...rest }) => {
    if (error) {
        console.log(error);
        return (_jsx("div", { className: "sui-layout", children: _jsx("div", { className: "sui-layout-body", children: _jsxs("div", { className: "sui-layout-body__inner", children: [_jsx("div", { className: "sui-layout-sidebar", "data-testid": "sidebar", children: _jsx(SidebarSearchField, {}) }), _jsx("div", { className: `sui-search-error${className ? ` ${className}` : ""}`, ...rest, "data-testid": "errorView", children: _jsx(FormattedMessage, { id: "errorMessage" }) })] }) }) }));
    }
    return children;
};
